import { UserDummySmallIcon } from "../../assets";

const SpectraUsersSharedStack = ({ space }) => {
  const collaborators = space?.collaborators?.slice(-3).reverse() || [];

  return (
    <div className="relative w-12 h-4">
      {collaborators.map((user, index) => (
        <div
          key={user?.id || index}
          className="absolute top-0"
          style={{ right: `${index * 8}px`, zIndex: 3 - index }}
        >
          {user?.picture || user?.profile ? (
            <img
              src={user.picture ? user.picture : user?.profile}
              className="w-4 h-4 rounded-full border border-edge-hex-cccccc dark:border-edge-hex-616161"
              alt="user profile"
            />
          ) : (
            <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 bg-fill-add-surface border border-edge-hex-cccccc dark:border-edge-hex-616161">
              <UserDummySmallIcon />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SpectraUsersSharedStack;
